module.exports = __webpack_public_path__ + "static/media/Test2.bc44f475.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reportCards/Test2.png
// module id = 1217
// module chunks = 0